import Component from 'vue-class-component'
import Vue from 'vue'
import { IUser } from '../../model/user'
import userStore from '../../store/user/user-store'
import ReactButton from './ReactButton.vue'
import statementStore from '../../store/statement/statement-store'

@Component({
  name: 'jybeButton',
  props: ['statement'],
  components: { 'react-button' : ReactButton }
})
export default class JybeButton extends Vue {

  protected jybeStatement (): void {
    statementStore.dispatchJybeStatement(this.$props['statement'])
  }

  protected unjybeStatement (): void {
    statementStore.dispatchUnjybeStatement(this.$props['statement'])
  }

}
